/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { matchesSearchTerms } from './search-text.function';

export const nameSearch = (name: any, searchText: string): boolean => matchesSearchTerms([name?.firstName, name?.lastName], searchText);
